// "Add photo or file · missing" -- there is no receipt-upload endpoint in
// M1 (execution plan §9.9's "no M1 endpoint" list). Rendered as an honest,
// disabled affordance rather than a working control that silently does
// nothing.
export function ReceiptSlot() {
  return (
    <div
      data-testid="receipt-slot"
      className="mt-3 flex h-14 items-center justify-center rounded-md border border-dashed border-input text-xs text-muted-foreground"
      aria-disabled="true"
      title="Receipt upload ships in a later milestone"
    >
      Add photo or file · missing
    </div>
  );
}

export default ReceiptSlot;
